module.exports = "<div class=\"b-recipes-search\">\n  <input type=\"text\" [disabled]=\"!searchToggleStatus\" autocomplete=\"off\" class=\"form-control\" #searchBox  id=\"search-box\" placeholder=\"Поиск\" aria-label=\"Поиск\" aria-describedby=\"basic-addon2\" [(ngModel)]=\"searchBoxValue\" (keyup)=\"search(searchBox.value, $event)\" >\n  <span *ngIf=\"searchBoxValue.length\" class=\"clear-button material-icons\" (click)=\"resetSearch()\">close</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recipes-search/recipes-search.component.html
// module id = ./src/app/recipes-search/recipes-search.component.html
// module chunks = main